// src/config.js
const config = {
    base_reset_confirm_url: 'https://bkkapi.favor100.site/reset_password_confirm',


    fastapiUrl: "https://bkkapi.favor100.site",
    fastapiResetUrl: "https://bkkapi.favor100.site",

  };
  
  export default config;


// base_reset_confirm_url: 'https://bkkapi.favor100.site/reset_password_confirm'
// base_reset_confirm_url: 'http://localhost:8000/reset_password_confirm'